import 'ui-theme/js/widgets/_publication-content';

+(function (UX) {
    const {loader} = UX;
    loader.truncation = {
        init() {},
        creativeWorkMeta() {},
    };
    loader.load.copyPastReferences = function ($articleReferences) {
        let articlesRefCopy = $articleReferences.clone();
        articlesRefCopy.appendTo(loader.tabReferences);
        articlesRefCopy.find('[id]').each(function () {
            //to remove duplicate Ids
            this.id = this.id + '_copied';
        });
    };
})(UX);
